export default {
  "fr": {
    "company_structure_innovation_id_list_373": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises innovantes"])},
    "company_structure_innovation_id_list_385": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises à mission"])}
  },
  "en": {
    
  }
}